(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
    (function () {
      const instances = new WeakMap();

      class FeaturedCollectionGenderFilter {
        constructor(root) {
          this.root = root;
          this.productLimit = parseInt(root.dataset.productLimit, 10) || 0;
          this.defaultGender = root.dataset.defaultGender || 'uomo';
          this.storageKey = root.dataset.storageKey;
          this.fieldset = root.querySelector('[data-gender-filter]');
          this.emptyState = root.querySelector('[data-gender-empty]');
          this.grid = root.querySelector('.product-grid');
          this.carousel = root.querySelector('carousel-slider');
          this.titleLink = root.querySelector('.has-paging__title');
          this.viewAllLink = root.querySelector('.view-all a');
          this.collectionUrlUomo = root.dataset.collectionUrlUomo || '';
          this.collectionUrlDonna = root.dataset.collectionUrlDonna || '';
          this.items = [...root.querySelectorAll('[data-gender-item]')];
          this.radios = this.fieldset
            ? [...this.fieldset.querySelectorAll('[data-gender-radio]')]
            : [];

          if (!this.fieldset || this.items.length === 0) {
            return;
          }

          this.onChange = this.handleChange.bind(this);
          this.fieldset.addEventListener('change', this.onChange);
          this.active = true;

          const saved = this.storageKey ? localStorage.getItem(this.storageKey) : null;
          const gender = saved === 'uomo' || saved === 'donna' ? saved : this.defaultGender;
          this.applyGender(gender, { persist: false });
        }

        handleChange(evt) {
          const input = evt.target;
          if (!input.matches('[data-gender-radio]')) return;
          this.applyGender(input.value, { persist: true });
        }

        applyGender(gender, { persist }) {
          const attr = gender === 'donna' ? 'data-gender-donna' : 'data-gender-uomo';
          let visibleCount = 0;

          this.items.forEach((item) => {
            const matches = item.getAttribute(attr) === 'true';
            const show = matches && visibleCount < this.productLimit;

            if (show) {
              visibleCount += 1;
              item.hidden = false;
              item.removeAttribute('aria-hidden');
            } else {
              item.hidden = true;
              item.setAttribute('aria-hidden', 'true');
            }
          });

          this.radios.forEach((radio) => {
            const isActive = radio.value === gender;
            radio.checked = isActive;
            radio.setAttribute('aria-checked', isActive ? 'true' : 'false');
          });

          if (this.emptyState) {
            const isEmpty = visibleCount === 0;
            this.emptyState.hidden = !isEmpty;
            if (this.grid) {
              this.grid.hidden = isEmpty;
              this.grid.setAttribute('aria-hidden', isEmpty ? 'true' : 'false');
            }
          }

          if (this.carousel && typeof this.carousel.refresh === 'function') {
            this.carousel.refresh();
          }

          const collectionUrl = gender === 'donna' ? this.collectionUrlDonna : this.collectionUrlUomo;
          if (collectionUrl) {
            if (this.titleLink) this.titleLink.href = collectionUrl;
            if (this.viewAllLink) this.viewAllLink.href = collectionUrl;
          }

          if (persist && this.storageKey) {
            try {
              localStorage.setItem(this.storageKey, gender);
            } catch (e) {
              /* quota / private mode */
            }
          }
        }

        destroy() {
          if (!this.active) return;
          this.fieldset.removeEventListener('change', this.onChange);
          this.active = false;
        }
      }

      function initFeaturedCollectionGender(scope) {
        const roots = scope.querySelectorAll('[data-featured-collection-gender]');
        roots.forEach((root) => {
          const existing = instances.get(root);
          if (existing) existing.destroy();

          const instance = new FeaturedCollectionGenderFilter(root);
          if (instance.active) {
            instances.set(root, instance);
          } else {
            instances.delete(root);
          }
        });
      }

      function destroyFeaturedCollectionGender(scope) {
        scope.querySelectorAll('[data-featured-collection-gender]').forEach((root) => {
          const instance = instances.get(root);
          if (instance) {
            instance.destroy();
            instances.delete(root);
          }
        });
      }

      initFeaturedCollectionGender(document);

      document.addEventListener('shopify:section:load', (evt) => {
        initFeaturedCollectionGender(evt.target);
      });

      document.addEventListener('shopify:section:unload', (evt) => {
        destroyFeaturedCollectionGender(evt.target);
      });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
